import { render } from "./MotorTestItemTable.vue?vue&type=template&id=60d58149&scoped=true"
import script from "./MotorTestItemTable.vue?vue&type=script&lang=js"
export * from "./MotorTestItemTable.vue?vue&type=script&lang=js"

import "./MotorTestItemTable.vue?vue&type=style&index=0&id=60d58149&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d58149"],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/TestItemComponent/MotorTestItemTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d58149"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d58149', __exports__)) {
    api.reload('60d58149', __exports__)
  }
  
  module.hot.accept("./MotorTestItemTable.vue?vue&type=template&id=60d58149&scoped=true", () => {
    api.rerender('60d58149', render)
  })

}


export default __exports__